module.exports = __webpack_public_path__ + "static/img/cloud2.2ad9536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/loading/cloud2.png
// module id = kzYN
// module chunks = 1